import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=ff85a242&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=ff85a242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff85a242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff85a242')) {
      api.createRecord('ff85a242', component.options)
    } else {
      api.reload('ff85a242', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=ff85a242&scoped=true&", function () {
      api.rerender('ff85a242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PVv6PT5ZrRrJ/JS/comp/DocBox.vue"
export default component.exports